// Belge Dizaynı — "AI canlı tasarlıyor" hayalet imleç katmanı (#138).
// Canlı streaming render ile SENKRON: ilk token gelene kadar imleç tuvalde gezinir
// ("Rona AI tasarlıyor"); elemanlar akarak çizilmeye başlayınca imleç her YENİ elemanın
// merkezine süzülür (sanki oraya yerleştiriyormuş gibi). Tamamen görseldir (pointerEvents:none);
// gerçek öğeler bu katmanın ALTINDA canlı çizilir.

import { useEffect, useState } from 'react';

const CURSOR_MOVE_MS = 420;

function rand(max) { return Math.random() * max; }

export function DesignerGhostOverlay({ thinking, liveElements, widthPx, heightPx, mmToPx }) {
  const els = liveElements || [];
  const count = els.length;
  const [cursor, setCursor] = useState({ x: widthPx * 0.5, y: heightPx * 0.4 });

  // İlk eleman gelene kadar gezin (bekleme/düşünme fazı).
  useEffect(() => {
    if (count > 0 || !thinking) return undefined;
    let timers = [];
    const wander = () => {
      setCursor({ x: rand(widthPx * 0.9) + widthPx * 0.05, y: rand(heightPx * 0.9) + heightPx * 0.05 });
      timers.push(setTimeout(wander, 550 + rand(350)));
    };
    wander();
    return () => timers.forEach(clearTimeout);
  }, [count, thinking, widthPx, heightPx]);

  // Her YENİ eleman eklendiğinde imleci onun merkezine taşı (canlı çizimle senkron).
  useEffect(() => {
    if (count <= 0) return;
    const el = els[count - 1];
    setCursor({ x: mmToPx((el.x || 0) + (el.width || 10) / 2), y: mmToPx((el.y || 0) + (el.height || 7) / 2) });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count]);

  const placing = count > 0;
  const label = placing ? `Rona AI yerleştiriyor… (${count})` : 'Rona AI tasarlıyor…';

  return (
    <div style={st.layer}>
      <style>{KEYFRAMES}</style>

      {/* Henüz eleman yokken mevcut tuvali hafifçe perdele (düşünme hissi). */}
      {!placing && <div style={{ ...st.wash, animation: 'rona-pulse 1.6s ease-in-out infinite' }} />}

      {/* Hayalet imleç */}
      <div style={{
        position: 'absolute', left: 0, top: 0,
        transform: `translate(${cursor.x}px, ${cursor.y}px)`,
        transition: `transform ${CURSOR_MOVE_MS}ms cubic-bezier(.4,0,.2,1)`,
        zIndex: 2, pointerEvents: 'none',
      }}>
        <div style={st.click} />
        <svg width="22" height="22" viewBox="0 0 24 24" style={{ filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.35))' }}>
          <path d="M4 2 L4 20 L9 15 L12.5 22 L15 21 L11.5 14 L18 14 Z" fill="#fff" stroke="var(--accent)" strokeWidth="1.4" strokeLinejoin="round" />
        </svg>
        <div style={st.badge}>
          <span style={st.spark}>✦</span> {label}
        </div>
      </div>
    </div>
  );
}

const KEYFRAMES = `
@keyframes rona-pulse { 0%,100% { opacity: 0.35 } 50% { opacity: 0.7 } }
@keyframes rona-spark { 0%,100% { opacity: 1; transform: scale(1) } 50% { opacity: 0.4; transform: scale(0.8) } }
`;

const st = {
  layer: { position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 5 },
  wash: { position: 'absolute', inset: 0, background: '#fff', opacity: 0.45 },
  click: { position: 'absolute', left: -6, top: -6, width: 18, height: 18, borderRadius: '50%', border: '2px solid rgba(0,115,234,0.5)', animation: 'rona-pulse 1.2s ease-in-out infinite' },
  badge: { position: 'absolute', left: 18, top: 14, whiteSpace: 'nowrap', background: 'var(--accent)', color: '#fff', fontSize: 11, fontWeight: 700, padding: '3px 8px', borderRadius: 999, boxShadow: '0 2px 8px rgba(0,115,234,0.4)' },
  spark: { display: 'inline-block', animation: 'rona-spark 0.9s ease-in-out infinite' },
};
